import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import MenuApi from "../../App/api/menu.apis";

// Thunk to fetch all countries
export const allCountry = createAsyncThunk(
  "countryData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await MenuApi.getAllCountry();
      // console.log("res", response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Fetching country data failed"
      );
    }
  }
);

// Slice using createSlice
const countryDataSlice = createSlice({
  name: "countryData",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(allCountry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(allCountry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the reducer to use in the store
export default countryDataSlice.reducer;
